export const skincarePaths = [
  '/business/showcase/skincare/home',
  '/business/showcase/skincare/live-diagnostics',
  '/business/showcase/skincare/hd-diagnostics',
  '/business/showcase/emulation/home',
  '/business/showcase/skincare/emulation',
];
